export default __webpack_public_path__ + "static/media/victor.6385c4b0.png";